/* 布局 */
//前台
import Layout from "@views/layout";

const goodswarehousebatchRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
            path: "goodswarehousebatch/list",
            name: "GOODSWAREHOUSEBATCH",
            meta: {
                title: "商品入库审核",
                keepAlive: true
            },
            component: () => import("@views/business/goodswarehousebatch/index.vue"),
        },
    ],
};

export default goodswarehousebatchRouter;
